import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './nav.css';
import Socials from '../socials/Socials'

function Nav({ inHome }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [scale, setScale] = useState(0);
    const location = useLocation();

    const toggleMenu = (e) => {
        e.stopPropagation();
        setIsMenuOpen(prevState => !prevState);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (!isMenuOpen){
                if (window.scrollY > 200 ) {
                setShowButton(true);
                } else {
                setShowButton(false);
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, [isMenuOpen]);

    useEffect(()=> {
        if (isMenuOpen) {
            setShowButton(true);
        } else if (!isMenuOpen && window.scrollY <= 200) {
            setShowButton(false);
        }
    },[isMenuOpen]);


    useEffect(() => {
        if (showButton) {
            const interval = setInterval(() => {
                setScale(prevScale => Math.min(prevScale + 0.03, 1));
            }, 10);

            return () => clearInterval(interval);
        } else {
            const interval = setInterval(() => {
                setScale(prevScale => Math.max(prevScale - 0.03, 0));
            }, 10);

            return () => clearInterval(interval);
        }
    }, [showButton]);

    const handleAnchor = (e, path) => {
        if (location.pathname === path) {
            e.preventDefault();
            window.location.reload();
        }
    };

    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isMenuOpen]);

  return (
    <div className='nav'>
        <div className="nav-container slide-in-bot-animation">
            <div className={inHome ? 'logo' : 'logo present'}>
                <div className="logo-top">
                    <Link to='/' onClick={(e) => handleAnchor(e, '/')}>
                        <span className='logo-text'>
                            <div className="credit">
                                <span>&copy;</span>
                            </div>
                            <div className="logo-name">
                                <span className='code-by'>
                                    Code by
                                </span>
                                <span className='bibhu'>
                                    <span className='bibhu-span'>Bibhu</span>
                                    <span className='prasad'>Prasad</span>
                                </span>
                            </div>
                        </span>
                    </Link>
                </div>
            </div>
            <div className="nav-options">
                <ul className={inHome ? 'main-list' : 'main-list present'}>
                <li className={/^\/work(\/\w+)?$/.test(location.pathname) ? 'nav-active' : ''}><Link to='/work' onClick={(e) => handleAnchor(e, '/work')}>Works</Link></li>
                <li className={location.pathname === '/sketches' ? 'nav-active' : ''}><Link to='/sketches' onClick={(e) => handleAnchor(e, '/sketches')}>Sketches</Link></li>
                <li className={location.pathname === '/about' ? 'nav-active' : ''}><Link to='/about' onClick={(e) => handleAnchor(e, '/about')}>About</Link></li>
                <li className={location.pathname === '/contact' ? 'nav-active' : ''}><Link to='/contact' onClick={(e) => handleAnchor(e, '/contact')}>Contact</Link></li>
                </ul>
                <ul className={inHome ? 'small-list' : 'small-list present'}>
                    <li className='nav-menu-option' onClick={toggleMenu}>Menu</li>
                </ul>
            </div>
        </div>
        <div className={`nav-btn-wraper ${isMenuOpen ? "btn-active" : ""}`} style={{ transform: `scale(${scale})`, opacity: scale }} >
            <div className="nav-btn" onClick={toggleMenu}>
                <div className="nav-btn-hov">
                </div>
                <div className="nav-btn-ico">
                    <div className={`btn-bars ${isMenuOpen ? "bars-active" : ""}`}></div>
                </div>
            </div>
        </div>
        <div className={`nav-menu ${isMenuOpen ? 'open': ''}`}>
            <div className="nav-blank-area" onClick={toggleMenu}></div>
            <div className="nav-area">
                <div className="nav-menu-container">
                    <div className="menu-top">
                        <h2>NAVIGATION</h2>
                        <hr />
                    </div>
                    <div className="menu">
                        <ul>
                            <Link to='/' onClick={(e) => handleAnchor(e, '/')}><li className={location.pathname === '/' ? 'slide-nav-active' : ''}>Home</li></Link>
                            <Link to='/work' onClick={(e) => handleAnchor(e, '/work')}><li className={/^\/work(\/\w+)?$/.test(location.pathname) ? 'slide-nav-active' : ''}>Works</li></Link>
                            <Link to='/sketches' onClick={(e) => handleAnchor(e, '/sketches')}><li className={location.pathname === '/sketches' ? 'slide-nav-active' : ''}>Sketches</li></Link>
                            <Link to='/about' onClick={(e) => handleAnchor(e, '/about')}><li className={location.pathname === '/about' ? 'slide-nav-active' : ''}>About</li></Link>
                            <Link to='/contact' onClick={(e) => handleAnchor(e, '/contact')}><li className={location.pathname === '/contact' ? 'slide-nav-active' : ''}>Contact</li></Link>
                        </ul>
                    </div>
                    <Socials/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Nav